import { useMount, useUpdateEffect, usePrevious } from 'ahooks';
import { useRouter } from 'next/router';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '../context/app.state';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  loading: {
    color: '#fff',
  },
}));

const Logout = (props) => {
  const classes = useStyles(props);
  const router = useRouter();
  const appContext = useAppContext();
  const { state, dispatch } = appContext;
  const { user } = state;
  const { isAuthenticated } = user;
  const { t } = useTranslation();

  const prevIsAuthenticated = usePrevious(isAuthenticated);

  useUpdateEffect(() => {
    if (prevIsAuthenticated === true && isAuthenticated === false) {
      // logout
      setTimeout(() => {
        router.push('/login');
      }, 500);
    }
  }, [isAuthenticated]);

  useMount(() => {
    dispatch({ type: 'logout' });

    setTimeout(() => {
      router.push('/login');
    }, 2000);
  });

  return (
    <div className={classes.root}>
      <Typography className={classes.loading}>
        {t('Loading...')}
      </Typography>
    </div>
  );
};

export default Logout;
